import * as Colors from 'components/Material/Styles/Colors';
import { Styles } from 'material-ui';

const { Spacing } = Styles;

const styles = {
  root: {
    padding: Spacing.desktopGutterMini,
    borderWidth: '1px',
    transition: 'all 1.5s ease'
  },
  progress: {
    margin: `${Spacing.desktopGutterMini}px 0`
  },
  incomplete: {
    backgroundColor: Colors.Colors.grey[200].material
  },
  correct: {
    backgroundColor: Colors.Colors.green[100].material
  },
  upload: {
    button: {
      marginLeft: Spacing.desktopGutterMini
    },
    input: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      top: 0,
      opacity: 0
    }
  },
  buttonContainer: {
    marginTop: Spacing.desktopGutterMini,
    marginBottom: Spacing.desktopGutterMini
  },
  incorrect: {
    backgroundColor: Colors.Colors.red[100].material
  },
  task: {
    margin: Spacing.desktopGutterLess
  },
  choices: {
    margin: `0 ${Spacing.desktopGutterLess}px ${Spacing.desktopGutter}px ${
      Spacing.desktopGutterLess
      }px`
  },
  container: {
  },
  uncorrected: {
    display: 'inline-block',
    background: 'white',
    marginRight: 5,
    marginBottom: 0,
    padding: '0px 3px',
    borderRadius: 5
  },
  question: {
    padding: Spacing.desktopGutterMini,
    boxSizing: 'border-box',
    fontWeight: 500,
    fontSize: '18px',
    minHeight: Spacing.desktopSubheaderHeight
  },
  answer: {
    controls: {
      padding: Spacing.desktopGutterMini
    },
    button: {
      marginRight: Spacing.desktopGutterMini
    },
    correct: {
      margin: Spacing.desktopGutterMini / 2
    },
    feedback: {
      margin: Spacing.desktopGutterMini / 2
    },
    incorrect: {
      margin: Spacing.desktopGutterMini / 2
    },
    root: {
      whiteSpace: 'pre-line',
      // lineHeight: '32px',
      boxSizing: 'border-box',
      borderStyle: 'none none solid none',
      borderColor: Colors.Text.Dark.divider,
      borderWidth: 1,
      position: 'relative',
      padding: `${Spacing.desktopGutterMini}px ${Spacing.iconSize +
        2 * Spacing.desktopGutterMini}px`,
      minHeight: Spacing.desktopSubheaderHeight
    },
    leftIcon: {
      position: 'absolute',
      left: Spacing.desktopGutterMini,
      top: '50%',
      marginTop: -16
    },
    rightIcon: {
      position: 'absolute',
      right: Spacing.desktopGutterMini,
      top: '50%',
      marginTop: -16
    }
  },
  radio: {
    verticalAlign: 'middle',
    position: 'absolute',
    left: Spacing.desktopGutterMini,
    top: 0,
    padding: Spacing.desktopGutterMini / 2,
    width: Spacing.iconSize + Spacing.desktopGutterMini,
    height: Spacing.iconSize + Spacing.desktopGutterMini
  },
  label: {
    lineHeight: '32px',
    fontWeight: 300,
    position: 'relative',
    padding: `0 ${Spacing.desktopGutterMini}px 0 ${Spacing.iconSize +
      Spacing.desktopGutterMini * 3}px`
  },
  results: {
    padding: `0 ${Spacing.desktopGutterLess}px ${Spacing.desktopGutter}px ${
      Spacing.desktopGutterLess
      }px`
  },
  noResults: {
    backgroundColor: Colors.Colors.red[100].material,
    padding: Spacing.desktopGutter,
    fontSize: '18px',
    textAlign: 'center'
  },
  makeSelection: {
    backgroundColor: Colors.Colors.grey[100].material,
    padding: Spacing.desktopGutter,
    fontSize: '18px',
    textAlign: 'center'
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/js/components/Route/Task/Styles.js